<app-menu>
  <div class="wo2-shell" [attr.data-theme]="themeMode">
    <div class="wo2-page">
      <section class="wo2-command-bar">
        <div class="wo2-title-row">
          <div class="min-w-0">
            <div class="flex flex-wrap items-center gap-2.5">
              <h1 class="m-0 text-2xl font-black tracking-tight text-[var(--wo2-text)] sm:text-3xl">Work Orders</h1>
              <span *ngIf="loading" class="wo2-loading-pill">
                <span class="wo2-spinner"></span>
                Loading
              </span>
            </div>
          </div>

          <div class="wo2-actions">
            <label class="wo2-search">
              <i class="fa-solid fa-magnifying-glass"></i>
              <input
                type="search"
                [(ngModel)]="quickFilterInput"
                (ngModelChange)="onSearchChange($event)"
                placeholder="Search order, BOL, customer, city..."
                autocomplete="off"
                aria-label="Search work orders"
              >
              <button
                *ngIf="quickFilterInput"
                type="button"
                class="wo2-search-clear"
                title="Clear search"
                aria-label="Clear search"
                (click)="clearFilters()"
              >
                &#x2715;
              </button>
            </label>

            <button type="button" class="wo2-button" (click)="resetView()">
              <i class="fa-solid fa-rotate-left"></i>
              <span>Reset</span>
            </button>
            <button type="button" class="wo2-button" (click)="toggleColumnsPanel()">
              <i class="fa-solid fa-table-columns"></i>
              <span>Columns</span>
            </button>
            <button type="button" class="wo2-button" (click)="toggleTheme()">
              <i class="fa-solid" [ngClass]="themeMode === 'dark' ? 'fa-sun' : 'fa-moon'"></i>
              <span>{{ themeMode === 'dark' ? 'Light' : 'Dark' }}</span>
            </button>
            <button type="button" class="wo2-button wo2-button--primary" (click)="refreshData()" [disabled]="loading">
              <i class="fa-solid fa-rotate"></i>
              <span>Refresh</span>
            </button>
          </div>
        </div>

        <div class="wo2-scope-row" role="group" aria-label="Work-order scope">
          <button
            *ngFor="let option of scopeOptions"
            type="button"
            class="wo2-scope"
            [class.is-active]="scope === option.key"
            [attr.aria-pressed]="scope === option.key"
            [title]="option.description"
            (click)="setScope(option.key)"
          >
            {{ option.label }}
          </button>
          <span class="wo2-scope-note" *ngIf="scope === 'current'">
            <i class="fa-solid fa-infinity"></i>
            No date cap
          </span>
        </div>

        <div class="wo2-insights">
          <button
            *ngFor="let insight of insights"
            type="button"
            class="wo2-insight"
            [ngClass]="'wo2-insight--' + insight.tone"
            [class.is-active]="isInsightActive(insight.key)"
            [attr.aria-pressed]="isInsightActive(insight.key)"
            [title]="insight.title || insight.label"
            (click)="applyInsight(insight.key)"
          >
            <span class="wo2-insight-icon">
              <i class="fa-solid" [ngClass]="insight.icon"></i>
            </span>
            <span class="min-w-0">
              <span class="wo2-insight-value" [class.is-loading]="statsLoading">{{ insight.value | number }}</span>
              <span class="wo2-insight-label">{{ insight.label }}</span>
            </span>
          </button>
        </div>
      </section>

      <div *ngIf="errorMessage" class="wo2-error" role="alert">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <div class="min-w-0 flex-1">
          <p class="m-0 font-black">Grid load issue</p>
          <p class="m-0 mt-0.5">{{ errorMessage }}</p>
        </div>
        <button type="button" aria-label="Dismiss" (click)="errorMessage = ''">&#x2715;</button>
      </div>

      <section class="wo2-grid-shell">
        <div *ngIf="loading && !hasLoaded" class="wo2-first-load">
          <span class="wo2-spinner wo2-spinner--large"></span>
          <span>Loading work orders&hellip;</span>
        </div>

        <ag-grid-angular
          *ngIf="gridReady"
          [class]="themeClass"
          class="wo2-grid"
          [gridOptions]="gridOptions"
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          [rowModelType]="rowModelType"
          [initialState]="initialState"
          [getRowId]="getRowId"
          (gridReady)="onGridReady($event)"
          (stateUpdated)="onStateUpdated($event)"
        ></ag-grid-angular>
      </section>
    </div>
    <app-work-order-panel
      [themeMode]="themeMode"
      (saved)="onPanelSaved()"
    ></app-work-order-panel>
  </div>
</app-menu>
